var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg555(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30.291 26.825H91.153V87.687H30.291z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M124.815 26.826H185.677V87.689H124.815z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30.291 123.124H91.153V183.98499999999999H30.291z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M124.815 123.125H185.677V183.987H124.815z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M219.645 27.115H280.50600000000003V87.977H219.645z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M314.168 27.116H375.031V87.97800000000001H314.168z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M219.645 123.415H280.50600000000003V184.276H219.645z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M314.168 123.416H375.031V184.278H314.168z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30.291 219.713H91.153V280.577H30.291z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M124.815 219.713H185.677V280.577H124.815z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30.291 316.011H91.153V376.874H30.291z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M124.815 316.013H185.677V376.87399999999997H124.815z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M219.645 219.713H280.50600000000003V280.575H219.645z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M314.168 219.713H375.031V280.577H314.168z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M219.645 316.011H280.50600000000003V376.874H219.645z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M314.168 316.013H375.031V376.87399999999997H314.168z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M408.691 27.116H469.554V87.97800000000001H408.691z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M408.691 123.416H469.554V184.278H408.691z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M408.691 219.713H469.554V280.577H408.691z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M408.691 316.013H469.554V376.87399999999997H408.691z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30.444 412.312H91.306V473.175H30.444z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M124.968 412.315H185.83V473.176H124.968z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M219.798 412.312H280.66V473.175H219.798z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M314.32 412.315H375.185V473.176H314.32z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M408.843 412.315H469.708V473.176H408.843z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg555);
export default __webpack_public_path__ + "static/media/555.156d0c9e31c99552807f41411cfe8ace.svg";
export { ForwardRef as ReactComponent };